import { COLORS } from './styles.ts';

interface Props {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  error: string | null;
}

export function DistanceDialog({ value, onChange, onSubmit, onCancel, error }: Props) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(7,8,16,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
      }}
    >
      <div
        style={{
          background: COLORS.bg,
          border: `1px solid ${COLORS.border}`,
          borderRadius: 10,
          padding: 24,
          minWidth: 360,
        }}
      >
        <div
          style={{
            fontFamily: "'Syne', sans-serif",
            fontSize: 18,
            fontWeight: 700,
            marginBottom: 6,
            color: COLORS.text,
          }}
        >
          Real-world distance
        </div>
        <div style={{ fontSize: 12, color: COLORS.textMuted, marginBottom: 14 }}>
          Distance between the two clicked points, in feet.
        </div>
        <input
          type="text"
          autoFocus
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onSubmit();
            if (e.key === 'Escape') onCancel();
          }}
          placeholder="e.g. 50"
          style={{
            width: '100%',
            boxSizing: 'border-box',
            background: 'rgba(255,255,255,0.04)',
            border: `1px solid ${COLORS.border}`,
            borderRadius: 6,
            color: COLORS.text,
            fontSize: 15,
            padding: '10px 12px',
            fontFamily: "'Outfit', sans-serif",
            outline: 'none',
            marginBottom: error ? 8 : 14,
          }}
        />
        {error && (
          <div style={{ fontSize: 12, color: COLORS.red, marginBottom: 14 }}>{error}</div>
        )}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onCancel}
            style={{
              background: 'transparent',
              border: `1px solid ${COLORS.border}`,
              color: COLORS.textMuted,
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 11,
              letterSpacing: '0.1em',
              padding: '8px 14px',
              borderRadius: 5,
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSubmit}
            style={{
              background: COLORS.accentSoft,
              border: `1px solid ${COLORS.accentBorder}`,
              color: COLORS.accent,
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 11,
              letterSpacing: '0.1em',
              padding: '8px 14px',
              borderRadius: 5,
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            Set scale
          </button>
        </div>
      </div>
    </div>
  );
}
